'use strict';

angular.module('client.services').factory('loggingService', ['$resource', 'api_server',
  function ($resource, api_server) {

    var logResource = $resource(api_server + '/log', {}, {
      log: { method: 'POST' }
    });

    function log(type, message) {
      return logResource.log({}, {
        type: type,
        message: message
      }).$promise;
    }

    return {
      log: log
    };
  }]);
